import { alpha, type Theme } from '@mui/material/styles';

/**
 * The soft filled input of the redesign dialogs (the recipe `add-licence-dialog`
 * introduced): label above rather than floating, a theme-aware fill (a
 * white-alpha fill vanishes on the light dialog's white paper) and the
 * `focusRing` token rather than `primary.main`, whose brand teal only reaches
 * 1.53:1 on a light canvas. Shared by the licence fields and by the
 * type-the-name deletion dialog, so the app's dialogs cannot drift apart.
 */
export const softFieldSx = (t: Theme) => {
  const light = t.palette.mode === 'light';
  const fill = light ? t.palette.grey[100] : alpha(t.palette.common.white, 0.05);
  const fillHover = light ? t.palette.grey[200] : alpha(t.palette.common.white, 0.08);
  const border = light ? t.palette.grey[400] : alpha(t.palette.common.white, 0.12);
  return {
    '& .MuiFilledInput-root': {
      borderRadius: '10px',
      backgroundColor: fill,
      border: `1px solid ${border}`,
      transition: 'background-color .15s, box-shadow .15s, border-color .15s',
      '&:hover': { backgroundColor: fillHover },
      '&.Mui-focused': {
        backgroundColor: fill,
        borderColor: t.palette.focusRing,
        boxShadow: `0 0 0 2px ${alpha(t.palette.focusRing, 0.5)}`,
      },
      '&.Mui-error': {
        borderColor: t.palette.error.main,
        boxShadow: `0 0 0 2px ${alpha(t.palette.error.main, 0.4)}`,
      },
    },
    '& .MuiFilledInput-input': { py: 1.5 },
    // Flush-left with the label above (drop MUI's default indent) and a touch
    // more breathing room under the field.
    '& .MuiFormHelperText-root': { mx: 0, mt: 1.25 },
  };
};
